import { awsRum } from 'src/rum';

export const metricEmitter = {
  recordEvent: (name: string, data?: Record<string, string>) => {
    awsRum?.recordEvent(name, data || {});
  },
};
